module.exports = __webpack_public_path__ + "static/img/contact.45dbd6df.png";